import { useTranslation } from 'react-i18next';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './TimeFilter.module.css';
import { useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import { LeagueContext } from 'context/leagueContext';
import {
  dayKeyLabel,
  OFFER_WINDOW_KEYS,
  upcomingDayKeys,
} from 'helpers/offerWindow';

/** Labels of the fixed windows; named days are labelled by their date. */
const WINDOW_LABELS: Record<string, string> = {
  '1h': '1_hour_label',
  '3h': '3_hours_label',
  today: 'today_label',
  tomorrow: 'tomorrow_label',
  '24h': '24_hours_label',
  '3d': '3_days_label',
  all: 'long_term_label',
};

/** Which part of the offer to show: today, tomorrow, a named day, hours. */
export const TimeFilter = () => {
  const { t, i18n } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(false);
  const { windowKey, setOfferWindow } = useContext(LeagueContext);
  const days = useMemo(() => upcomingDayKeys(5), []);

  const label = (key: string) =>
    WINDOW_LABELS[key]
      ? t(WINDOW_LABELS[key])
      : dayKeyLabel(key, i18n.language);

  const pick = (key: string) => {
    setExpanded(false);
    setOfferWindow(key);
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.selectedValue}
        onClick={() => setExpanded(!expanded)}
      >
        {label(windowKey ?? 'all')}
        <ThemeIcon icon="chevron-down" alt="Expand/Collapse" variant="inline" />
      </div>
      <div
        className={classNames(styles.optionsWrapper, {
          [styles['optionsExpanded']]: expanded,
        })}
      >
        {[
          ...OFFER_WINDOW_KEYS.slice(0, 4),
          ...days,
          ...OFFER_WINDOW_KEYS.slice(4),
        ].map((key) => (
          <div
            key={key}
            className={classNames(styles.option, {
              [styles.optionSelected]: key === windowKey,
            })}
            onClick={() => pick(key)}
          >
            {label(key)}
          </div>
        ))}
      </div>
    </div>
  );
};
